import { type PlayerPublic } from "@aura-frontend/omnibus-az-client";

import { splitName } from "@/utils/splitName";

export const convertPlayersToCsv = (players: PlayerPublic[]) => {
  const csvHeader = "first,last,id,throws,bats,number";
  console.log("[convertPlayersToCsv] Converting players:", players);

  const csvContent = players
    .map((player) => {
      const { firstName, lastName } = splitName(player.known_names[0]);
      const playerRecord = player as unknown as Record<string, unknown>;
      const number =
        (playerRecord.number as string | number | undefined) ||
        (playerRecord.jerseyNumber as string | number | undefined) ||
        "";
      console.log(`[convertPlayersToCsv] Player ${player.known_names[0]}:`, {
        number,
        allKeys: Object.keys(player),
      });
      return `${firstName?.trim() ?? ""},${lastName?.trim() ?? ""},${player.external_ids[0]},${player.pitch_side},${player.hit_side},${number}`;
    })
    .join("\n");

  const result = `${csvHeader}\n${csvContent}`;
  console.log("[convertPlayersToCsv] Final CSV content:", result);
  return result;
};
